import mixpanel from "mixpanel-browser";

export const sendEvent = (eventName: string, properties?: any) => {
  mixpanel.track(eventName, {
    ...properties,
    source: "pos",
  });
};
